import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import React from "react";

// Auth Pages

import Login from "./pages/Login";
import OtpPage from "./pages/OtpPage";
import ForgotPassword from "./pages/ForgotPassword";
import PasswordReset from "./pages/PasswordReset";
import SetPassword from "./pages/SetPassword";

// Route Guards
import PublicRoute from "./components/PublicRoute";
import ProtectedRoute from "./components/ProtectedRoute";
import RoleProtectedRoute from "./components/RoleProtectedRoute";
import RestrictedOtpRoute from "./components/RestrictedOtpRoute";
import RestrictedResetRoute from "./components/RestrictedResetRoute";

// Layout & Protection
import Layout from "./components/Layout";

// Dashboard Pages
import Dashboard from "./pages/Dashboard";
import Projects from "./pages/Projects";
import MyWork from "./pages/MyWork";

import Kanban from "./pages/Kanban";
import Reports from "./pages/Reports";
import Timeline from "./pages/Timeline";
import LeaveManagement from "./pages/leavetrack";
import HolidayList from "./pages/HolidayList";
import MyAssets from "./pages/MyAssets";

// Error Page
import NotFound from "./pages/NotFound";
import SetUpProfile from "./pages/SetUpProfile";
import UploadDocuments from "./pages/UploadDocuments";
import Congrats from "./pages/Congrats";
import Settings from "./pages/Settings";
import Resources from "./pages/Settings/Resources";
import Roles from "./pages/Settings/Roles";
import ProjectAccess from "./pages/Settings/ProjectAccess";
import AssetManagement from "./pages/Settings/AssetManagement";
import Contacts from "./pages/Settings/Contacts";

export default function App() {
  return (
    <Router>
      <Routes>
        {/* ─────────────────────────────────────────────
            AUTH ROUTES — Public routes (protected from logged-in users)
            ───────────────────────────────────────────── */}

        {/* LOGIN - prevent logged-in users from accessing */}
        <Route
          path="/"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />

        {/* FORGOT PASSWORD - prevent logged-in users from accessing */}
        <Route
          path="/forgot-password"
          element={
            <PublicRoute>
              <ForgotPassword />
            </PublicRoute>
          }
        />

        {/* OTP PAGE - only accessible after forgot-password submission */}
        <Route
          path="/otp"
          element={
            <RestrictedOtpRoute>
              <OtpPage />
            </RestrictedOtpRoute>
          }
        />

        {/* RESET PASSWORD - only accessible after OTP verification */}
        <Route
          path="/reset-password"
          element={
            <RestrictedResetRoute>
              <PasswordReset />
            </RestrictedResetRoute>
          }
        />

        {/* SET PASSWORD (invite link) - public but handled separately */}
        <Route path="/set-password" element={<SetPassword />} />
        <Route path="/setup-profile" element={<SetUpProfile />} />
        <Route path="/upload-documents" element={<UploadDocuments />} />
        <Route path="/congrats" element={<Congrats />} />

        {/* ─────────────────────────────────────────────
            DASHBOARD ROUTES — Protected routes (for authenticated users only)
            ───────────────────────────────────────────── */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="projects" element={<Projects />} />
          <Route path="projects/:projectRef" element={<Projects />} />
          <Route path="kanban" element={<Kanban />} />
          <Route path="my-work" element={<MyWork />} />

          <Route path="kanban/:projectRef" element={<Kanban />} />

          <Route
            path="reports"
            element={
              <RoleProtectedRoute allowedRoles={["admin", "manager"]}>
                <Reports />
              </RoleProtectedRoute>
            }
          />
          <Route path="timeline" element={<Timeline />} />
          <Route path="leave" element={<LeaveManagement />} />
          <Route path="leave/manage" element={<LeaveManagement />} />
          <Route path="holiday-list" element={<HolidayList />} />
          <Route path="my-assets" element={<MyAssets />} />

          <Route
            path="settings"
            element={
              <RoleProtectedRoute allowedRoles={["admin", "manager"]}>
                <Settings />
              </RoleProtectedRoute>
            }
          >
            <Route index element={<Resources />} />
            <Route path="project-access" element={<ProjectAccess />} />
            <Route path="roles" element={<Roles />} />
            <Route path="assets-management" element={<AssetManagement />} />
            <Route path="contacts" element={<Contacts />} />
          </Route>
        </Route>

        {/* Catch-all for 404 */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}
